import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-home",
  "use": "icon-menu-home-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-menu-home\">\r\n<path d=\"M196,93.6c-10.4-12.3-22.1-25.5-34.4-39.7c-12.4-14.1-25.4-28.8-37.2-42.8c-14.7-14.7-30.8-15-44.4-0.4\r\n\tC68.6,23.4,55.8,37,43.1,50.3c-12.4,13.3-25.5,26.8-37,39.7c-7.9,9-6.5,16.4-4.9,19.9c2.5,5.5,8.2,8.9,12.3,8.9h17.6V179\r\n\tc0,10.2,7.2,21,17.9,21h34.3v-59.8h37.5V200h34.6c6.8,0,17.9-5.4,17.9-25.7v-55.6h13c5.1,0,9.6-2.7,11.9-7.2\r\n\tC201.3,106.2,200.4,99.7,196,93.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu/menu-home.svg
// module id = 1Kzt
// module chunks = 13